import React from "react"

import { Button } from "@coval/ui"

import { EVENTS, useEventDispatcher } from "../../event-bus"

export const AddTestCaseButton: React.FC = () => {
  const dispatch = useEventDispatcher()

  const handleManualAdd = () => {
    const newTestCase = {
      id: `new-${Date.now()}`,
      input_str: "",
      expected_behaviors: [],
      expected_output_json: null,
      s3_key: null,
      s3_bucket: null,
      input_type: "SCENARIO",
      script_turns: null,
    }
    dispatch(EVENTS.TEST_CASE_ADD, { testCase: newTestCase })
  }

  return (
    <Button onClick={handleManualAdd} data-testid="test-set-add-case-button">
      Add Test Case
    </Button>
  )
}
